var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { freezeWindowScroll, releaseWindowScroll, EMAIL_RE } from '../common/utils';
import { frontEndApi, isSafari } from '../common/utils';
import { dispatchGtmEvent } from '../common/gtm';
export function initDialogs(modules, triggers) {
    var root = document.getElementById('dialogOverlay');
    if (!root) {
        return;
    }
    var dialog = getDialog();
    modules.filter(function (m) { return m.name === 'ContactDialog'; }).forEach(function (_a) {
        var el = _a.el;
        return initContactDialog(el);
    });
    triggers.filter(function (t) { return t.module === 'ContactDialog'; }).forEach(function (t) {
        t.el.addEventListener('click', function () {
            t.el.dispatchEvent(new Event("AC.ContactDialog.".concat(t.action || 'toggle'), {
                cancelable: true,
                bubbles: true,
            }));
        });
    });
    modules.filter(function (m) { return m.name === 'JobApplicationDialog'; }).forEach(function (_a) {
        var el = _a.el;
        return initJobApplicationDialog(el);
    });
    triggers.filter(function (t) { return t.module === 'JobApplicationDialog'; }).forEach(function (t) {
        t.el.addEventListener('click', function () {
            t.el.dispatchEvent(new Event("AC.JobApplicationDialog.".concat(t.action || 'toggle'), {
                cancelable: true,
                bubbles: true,
            }));
        });
    });
    function initContactDialog(contact) {
        var steps = {
            form: contact.querySelector('[data-dialog-step="form"]'),
            success: contact.querySelector('[data-dialog-step="success"]'),
            failure: contact.querySelector('[data-dialog-step="failure"]'),
        };
        var inputs = {
            email: steps.form.querySelector('[name="email"]'),
            message: steps.form.querySelector('[name="message"]'),
            country: steps.form.querySelector('[name="country"]'),
            consent: steps.form.querySelector('[name="consent"]'),
        };
        var submit = steps.form.querySelector('[type="submit"]');
        document.addEventListener('AC.ContactDialog.open', function (e) { return dialog.open(contact, steps.form); });
        document.addEventListener('AC.ContactDialog.close', function (e) { return dialog.close(contact); });
        document.addEventListener('AC.ContactDialog.restart', function (e) { return dialog.restart(contact, steps.form); });
        document.addEventListener('AC.ContactDialog.toggle', function (e) { return dialog.toggle(contact); });
        inputs.email.addEventListener('keyup', validateForm);
        inputs.consent.addEventListener('change', validateForm);
        inputs.country.addEventListener('change', validateForm);
        steps.form.addEventListener('submit', function (event) {
            event.preventDefault();
            validateForm() && sendForm();
        });
        function isFormValid() {
            return inputs.email.value && inputs.email.value.match(EMAIL_RE) && inputs.consent.checked;
        }
        function validateForm() {
            if (isFormValid() && !dialog.isWaiting()) {
                submit.removeAttribute('disabled');
                return true;
            }
            else {
                submit.setAttribute('disabled', 'disabled');
                return false;
            }
        }
        function sendForm() {
            return __awaiter(this, void 0, void 0, function () {
                var err_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            dialog.wait(contact);
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, frontEndApi.post('Common@sendContactEmail', {
                                    email: inputs.email.value,
                                    message: inputs.message.value,
                                    country: inputs.country.value,
                                    consent: inputs.consent.checked,
                                    meta: Object.assign(JSON.parse(steps.form.dataset.meta || '{}') || {}, {
                                        url: window.location.href,
                                        ui: 'ContactForm',
                                    }),
                                })];
                        case 2:
                            _a.sent();
                            inputs.message.value = '';
                            inputs.consent.checked = false;
                            dialog.open(contact, steps.success);
                            dispatchGtmEvent('AC.ContactRequest.Submit.success', {
                                formId: 'ContactDialog',
                            });
                            return [3 /*break*/, 4];
                        case 3:
                            err_1 = _a.sent();
                            dialog.open(contact, steps.failure);
                            console.warn(err_1);
                            dispatchGtmEvent('AC.ContactRequest.Submit.failure', {
                                formId: 'ContactDialog',
                                failureReason: err_1,
                            });
                            return [3 /*break*/, 4];
                        case 4:
                            dialog.releaseWait(contact);
                            return [2 /*return*/];
                    }
                });
            });
        }
    }
    function initJobApplicationDialog(jobApplication) {
        var steps = {
            form: jobApplication.querySelector('[data-dialog-step="form"]'),
            success: jobApplication.querySelector('[data-dialog-step="success"]'),
            failure: jobApplication.querySelector('[data-dialog-step="failure"]'),
        };
        var inputs = {
            email: steps.form.querySelector('[name="email"]'),
            name: steps.form.querySelector('[name="name"]'),
            message: steps.form.querySelector('[name="message"]'),
            cv: steps.form.querySelector('[name="cv"]'),
            document: steps.form.querySelector('[name="document"]'),
            consent: steps.form.querySelector('[name="consent"]'),
        };
        var submit = steps.form.querySelector('[type="submit"]'), cvPicker = steps.form.querySelector('.is--cv .filePicker'), documentPicker = steps.form.querySelector('.is--document .filePicker'), cvFileNames = steps.form.querySelector('.is--cv .fileNames'), documentFileNames = steps.form.querySelector('.is--document .fileNames');
        document.addEventListener('AC.JobApplicationDialog.open', function (e) { return dialog.open(jobApplication, steps.form); });
        document.addEventListener('AC.JobApplicationDialog.close', function (e) { return dialog.close(jobApplication); });
        document.addEventListener('AC.JobApplicationDialog.restart', function (e) { return dialog.restart(jobApplication, steps.form); });
        document.addEventListener('AC.JobApplicationDialog.toggle', function (e) { return dialog.toggle(jobApplication); });
        inputs.name.addEventListener('keyup', validateForm);
        inputs.email.addEventListener('keyup', validateForm);
        inputs.consent.addEventListener('change', validateForm);
        inputs.cv.addEventListener('change', validateForm);
        inputs.document.addEventListener('change', validateForm);
        steps.form.addEventListener('submit', function (event) {
            event.preventDefault();
            validateForm() && sendForm();
        });
        cvPicker.addEventListener('click', function () {
            inputs.cv.click();
        });
        documentPicker.addEventListener('click', function () {
            inputs.document.click();
        });
        inputs.cv.addEventListener('change', function (event) {
            var files = [].slice.apply(inputs.cv.files);
            cvFileNames.innerHTML = files.map(function (f) { return "<span><span class=\"icon icon-file\"></span>".concat(f.name, "</span>"); })
                .join('');
            dialog.updateSize();
        });
        inputs.document.addEventListener('change', function (event) {
            var files = [].slice.apply(inputs.document.files);
            documentFileNames.innerHTML = files.map(function (f) { return "<span><span class=\"icon icon-file\"></span>".concat(f.name, "</span>"); })
                .join('');
            dialog.updateSize();
        });
        function isFormValid() {
            return inputs.name.value && inputs.cv.value && inputs.email.value && inputs.email.value.match(EMAIL_RE) && inputs.consent.checked;
        }
        function validateForm() {
            if (isFormValid() && !dialog.isWaiting()) {
                submit.removeAttribute('disabled');
                return true;
            }
            else {
                submit.setAttribute('disabled', 'disabled');
                return false;
            }
        }
        function sendForm() {
            return __awaiter(this, void 0, void 0, function () {
                var event, extra, cvFiles_1, documentFiles_1, cvFileData, _a, documentFileData, _b, err_2;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            dialog.wait(jobApplication);
                            event = 'AC.JobApplicationDialog.submit.failure';
                            _c.label = 1;
                        case 1:
                            _c.trys.push([1, 7, , 8]);
                            extra = JSON.parse(steps.form.dataset.meta || '{}') || {}, cvFiles_1 = [].slice.apply(inputs.cv.files), documentFiles_1 = [].slice.apply(inputs.document.files);
                            if (!cvFiles_1.length) {
                                console.warn('No files were selected', cvFiles_1);
                                dialog.open(jobApplication, steps.failure);
                                dialog.releaseWait(jobApplication);
                                return [2 /*return*/];
                            }
                            _a = cvFiles_1;
                            if (!_a) return [3 /*break*/, 3];
                            return [4 /*yield*/, (new Promise(function (resolve, reject) {
                                    var reader = new FileReader();
                                    reader.onerror = reject;
                                    reader.onload = function () { return resolve(reader.result); };
                                    reader.readAsDataURL(cvFiles_1[0]);
                                }))];
                        case 2:
                            _a = (_c.sent());
                            _c.label = 3;
                        case 3:
                            cvFileData = _a;
                            _b = documentFiles_1;
                            if (!_b) return [3 /*break*/, 5];
                            return [4 /*yield*/, (new Promise(function (resolve, reject) {
                                    var reader = new FileReader();
                                    reader.onerror = reject;
                                    reader.onload = function () { return resolve(reader.result); };
                                    if (documentFiles_1.length > 0) {
                                        reader.readAsDataURL(documentFiles_1[0]);
                                    }
                                    else {
                                        resolve('');
                                    }
                                }))];
                        case 4:
                            _b = (_c.sent());
                            _c.label = 5;
                        case 5:
                            documentFileData = _b;
                            return [4 /*yield*/, frontEndApi.post('Common@sendJobApplication', __assign(__assign({}, extra), { email: inputs.email.value, message: inputs.message.value, consent: inputs.consent.checked, name: inputs.name.value, cv: cvFileData, cv_filename: cvFiles_1[0].name, document: documentFileData, document_filename: documentFiles_1[0] ? documentFiles_1[0].name : '' }))];
                        case 6:
                            _c.sent();
                            inputs.message.value = '';
                            inputs.consent.checked = false;
                            inputs.cv.value = '';
                            dialog.open(jobApplication, steps.success);
                            event = 'AC.JobApplicationDialog.submit.success';
                            return [3 /*break*/, 8];
                        case 7:
                            err_2 = _c.sent();
                            dialog.open(jobApplication, steps.failure);
                            console.warn(err_2);
                            return [3 /*break*/, 8];
                        case 8:
                            jobApplication.dispatchEvent(new CustomEvent(event, {
                                cancelable: true,
                                bubbles: true,
                                detail: {},
                            }));
                            dialog.releaseWait(jobApplication);
                            return [2 /*return*/];
                    }
                });
            });
        }
    }
    function getDialog() {
        var visible = false, waiting = false, stack = [];
        document.addEventListener('AC.Dialog.close', function () { return close(); });
        window.addEventListener('resize', updateSize);
        window.addEventListener('orientationchange', updateSize);
        function updateSize() {
            if (stack.length) {
                stack.forEach(function (_a) {
                    var dialog = _a.dialog, step = _a.step;
                    if (step && step.classList.contains('is--active')) {
                        step.style.height = step.scrollHeight + 'px';
                    }
                });
            }
        }
        function show() {
            if (!stack.length) {
                return hide();
            }
            var _a = stack[stack.length - 1], dialog = _a.dialog, step = _a.step;
            dialog.classList.add('is--active');
            if (step) {
                var focus = step.querySelector('.dialog-step-focus');
                !isSafari() && focus && focus.focus();
                step.classList.add('is--active');
                step.style.height = step.scrollHeight + 'px';
            }
            visible = true;
            root.classList.add('is--visible');
            freezeWindowScroll();
        }
        function hide() {
            root.classList.remove('is--visible');
            releaseWindowScroll();
            visible = false;
        }
        function hideDialog(dialog, step) {
            dialog.classList.remove('is--active');
            var stepEls = step ? [step] : [].slice.apply(dialog.querySelectorAll('[data-dialog-step]'));
            stepEls.forEach(function (el) {
                el.classList.remove('is--active');
                el.style.height = '';
            });
        }
        function open(dialog, step) {
            var stepEl = step || dialog.querySelector('[data-dialog-step]');
            if (stack.length) {
                var prev = stack[stack.length - 1];
                hideDialog(prev.dialog, prev.step);
            }
            stack.push({ dialog: dialog, step: stepEl });
            show();
        }
        function restart(dialog, step) {
            close();
            open(dialog, step);
        }
        function close(dialog, step) {
            if (stack.length === 1 || !dialog) {
                stack.forEach(function (_a) {
                    var dialog = _a.dialog, step = _a.step;
                    return hideDialog(dialog, step);
                });
                stack = [];
            }
            else if (dialog) {
                stack = stack.filter(function (entry) {
                    if (entry.dialog === dialog || (step && entry.dialog !== dialog && entry.step !== step)) {
                        hideDialog(dialog, step);
                        return false;
                    }
                    return true;
                });
            }
            stack.length ? show() : hide();
        }
        function toggle(dialog, step) {
            visible ? close(dialog, step) : open(dialog, step);
        }
        function wait(dialog) {
            dialog.classList.add('is--waiting');
            waiting = true;
        }
        function releaseWait(dialog) {
            dialog.classList.remove('is--waiting');
            waiting = false;
        }
        function isWaiting() {
            return waiting;
        }
        return { restart: restart, open: open, close: close, toggle: toggle, wait: wait, releaseWait: releaseWait, isWaiting: isWaiting, updateSize: updateSize };
    }
}
